/** Marketing site origin (no trailing slash). */
export const SITE_URL = "https://sqaleshop.com"

export const SITE_DEFAULT_DESCRIPTION =
  "Sqaleshop is a powerful sales link that helps you sell your products and services with ease. It includes features for product management, inventory tracking, order processing, invoicing, and more."

export const SITE_DEFAULT_OG_IMAGE =
  "https://res.cloudinary.com/dowfglddo/image/upload/v1765285347/43f911eb-a473-42f0-9015-9605c995817b_txhivv_1_n27kir.webp"

export const APP_URL = "/dashboard"
export const APP_REGISTER_URL = "/register"
export const APP_LOGIN_URL = "/login"
export const APP_ONBOARDING_URL = "/onboarding"
/** In-app Paystack subscription / plan management */
export const APP_BILLING_URL = "/dashboard/settings#billing"
export const BLOG_URL = "https://blog.sqaleshop.com"
export const TIKTOK_URL = "https://www.tiktok.com/@sqaleshop"

/** Homepage hero demo video. */
export const HERO_YOUTUBE_VIDEO_ID = "kkkaKbNTvCE"
export const HERO_YOUTUBE_WATCH_URL = `https://www.youtube.com/watch?v=${HERO_YOUTUBE_VIDEO_ID}`
